export default {
    "name": "CreateInventoryType",
    "kind": "HoudiniMutation",
    "hash": "f5448ac9e68d1bddb34dbe854b631ea414c86b4b2a4e7045f4dbc97cb44c1dc1",

    "raw": `mutation CreateInventoryType($input: NewInventoryType!) {
  createInventoryType(input: $input) {
    active
    id
    name
    setId
    vehicle
    taxCode
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "createInventoryType": {
                "type": "InventoryType",
                "keyRaw": "createInventoryType(input: $input)",

                "selection": {
                    "fields": {
                        "active": {
                            "type": "Boolean",
                            "keyRaw": "active",
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "setId": {
                            "type": "Int",
                            "keyRaw": "setId",
                            "nullable": true,
                            "visible": true
                        },

                        "vehicle": {
                            "type": "Boolean",
                            "keyRaw": "vehicle",
                            "visible": true
                        },

                        "taxCode": {
                            "type": "String",
                            "keyRaw": "taxCode",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "NewInventoryType"
        },

        "types": {
            "NewInventoryType": {
                "active": "Boolean",
                "id": "Int",
                "modelInventoryTypeId": "Int",
                "name": "String",
                "partListAuthorityId": "Int",
                "pickable": "Boolean",
                "publicAllowed": "Boolean",
                "requireSerialization": "Boolean",
                "setId": "Int",
                "taxCode": "String",
                "typeLabel1": "String",
                "typeLabel2": "String",
                "typeLabel3": "String",
                "typeLabel4": "String",
                "useManufacturer": "Boolean",
                "vehicle": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=5bdb4c79e11f33ac09add87e306f345d282b0868d53fef400ee0f410acd20560";